import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { taskTypes, fileTypes, statusTypes, dropdownMenu } from "../../utils/constants";
import { Calendar } from 'primereact/calendar';
import { Nullable } from "primereact/ts-helpers";
import 'primeicons/primeicons.css';
import "./Logs.css";

const LogsFilterBar = ({
  logDate,
  setLogDate,
  fromDate,
  toDate,
  setDateRange,
  calendarVisible,
  setCalendarVisible,
  selectedTasks,
  setSelectedTasks,
  selectedFiles,
  setSelectedFiles,
  selectedStatuses,
  setSelectedStatuses,
  onClearFilter,
  onRefreshClick
}: any) => {

  const [nextDisabled, setNextDisabled] = React.useState(false);
  let today = new Date();
  let maxDate = new Date(today);

  let minDate = new Date(today);
  minDate.setMonth(minDate.getMonth() - 3);

  const handleDateChange = (direction: string) => {
    const newDate = new Date(logDate || new Date());

    if (direction === "next") {
      newDate.setDate(newDate.getDate() + 1);
    } else {
      newDate.setDate(newDate.getDate() - 1);
    }
    setLogDate(newDate);
  };

  // Auto-disable next arrow if date is today
  useEffect(() => {
    if (!logDate) {
      setNextDisabled(true); 
      return;
    }
  
    const current = new Date(logDate);
    current.setHours(0, 0, 0, 0);
  
    const max = new Date();
    max.setHours(0, 0, 0, 0);
  
    setNextDisabled(current >= max);
  }, [logDate]);
  

  return (
    <div className="filter-bar">
      <span
        className="pi pi-chevron-left"
        style={{ cursor: "pointer" }}
        onClick={() => handleDateChange("previous")}
      />

      <Calendar
        className="calendar"
        placeholder={logDate?.toLocaleDateString("en-GB") ?? "Today"}
        value={logDate}
        dateFormat="dd/mm/yy"
        maxDate={maxDate}
        minDate={minDate}
        showButtonBar
        disabled
      />

      {!nextDisabled && (
        <span
          className="pi pi-chevron-right"
          style={{ cursor: "pointer" }}
          onClick={() => handleDateChange("next")}
        />
      )}

      <MultiSelect
        value={selectedTasks}
        options={taskTypes.map((t) => ({ label: t, value: t }))}
        onChange={(e) => setSelectedTasks(e.value)}
        placeholder="Tasks"
        className="multiselect md:w-20rem"
        display="chip"
      />

      <MultiSelect
        value={selectedFiles}
        options={fileTypes.map((f) => ({ label: f, value: f }))}
        onChange={(e) => setSelectedFiles(e.value)}
        placeholder="Files"
        className="multiselect md:w-20rem"
        display="chip"
        filter
      />

      <MultiSelect
        value={selectedStatuses}
        options={statusTypes.map((s) => ({ label: s, value: s }))}
        onChange={(e) => setSelectedStatuses(e.value)}
        placeholder="Status"
        className="multiselect md:w-20rem"
        display="chip"
      />
      <i
        className="pi pi-filter-slash"
        style={{ cursor: "pointer" }}
        onClick={onClearFilter}
        title="Clear Filters"
      />

      <i
        className="pi pi-refresh refresh-arrow"
        onClick={onRefreshClick}
        title="Refresh Logs"
      />
    </div>
  );
};

export default LogsFilterBar;
